<section class="courses-page">
  <div class="page-header">
    <div>
      <h1>Quizzes</h1>
      <p>Manage all quizzes across courses</p>
    </div>

    <ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
      <button class="add-btn" (click)="openSelectQuizTypeDialogBox()">
        <span class="material-icons">add</span>
        Add Quiz
      </button>
    </ng-container>
  </div>

  <div class="sub-header">
    <h2>
      Manage Quizzes
      <span class="count">{{ totalQuiz }}</span>
    </h2>
  </div>
  <div class="toolbar">
    <div class="search-box">
      <span class="material-icons search-icon">search</span>
      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
        placeholder="Search..."
      />
      <span
        *ngIf="searchText"
        class="material-icons clear-icon"
        (click)="clearSearch()">
        close
      </span>
    </div>
    <div class="filter-box">
      <select [(ngModel)]="selectedStatus" (change)="onStatusChange()">
        <option value="all">All</option>
        <option value="Draft">Draft</option>
        <option value="Published">Published</option>
      </select>
    </div>
  </div>
  <div class="course-grid" *ngIf="isLoading">
    <div class="course-card skeleton" *ngFor="let _ of [].constructor(limit)">
      <div class="skeleton-header">
        <div class="skeleton-icon"></div>
        <div class="skeleton-badge"></div>
      </div>

      <div class="skeleton-line title"></div>
      <div class="skeleton-line small"></div>
      <div class="skeleton-btn"></div>
    </div>
  </div>

  <div class="no-data" *ngIf="!isLoading && quizzes.length === 0">
    <span class="material-icons no-data-icon">quiz</span>
    <h3>No quizzes created yet</h3>
    <p>Create your first quiz to assess learners.</p>

    <ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
      <button class="add-btn" (click)="openSelectQuizTypeDialogBox()">
        <span class="material-icons">add</span>
        Create First Quiz
      </button>
    </ng-container>
  </div>

  <div class="course-grid" *ngIf="!isLoading && quizzes.length > 0">
    <div class="course-card" *ngFor="let quiz of quizzes">
      <div class="card-header-row">
        <div class="left"></div>

        <div class="card-top-right justify-content-between">
          <div class="d-flex">
          <span class="status" [ngClass]="quiz.status.toLowerCase()">
            {{ quiz.status | titlecase }}
          </span>

          <span class="link ms-2" *ngIf="quiz.status === 'Published' && quiz.links_count">
            <i class="bi bi-link"></i> {{ quiz.links_count }} Link
          </span>

          <span class="course-quiz ms-2"
          [ngClass]="{ course: quiz.mode === 'course_quiz',
          assessment: quiz.mode === 'proctored_assessment' }">
           {{ getQuizTypeLabel(quiz.mode || '') }}
        </span>
          </div>
          <div class="menu-wrapper">
            <button
              class="menu-btn"
              (click)="toggleMenu(quiz.quiz_id); $event.stopPropagation()">
              <span class="material-icons">more_vert</span>
            </button>

            <div class="menu-dropdown" *ngIf="openMenuId === quiz.quiz_id">
              <button class="menu-item" (click)="onEditQuiz(quiz)">
                <i class="bi bi-pencil"></i> Edit
              </button>

              <button class="menu-item danger" (click)="onDeleteQuiz(quiz)">
                <i class="bi bi-trash"></i> Delete
              </button>

              <button class="menu-item danger" (click)="onViewQuiz(quiz.quiz_id)">
                <i class="bi bi-star"></i> Review
              </button>
            </div>
          </div>
        </div>

        
      </div>

      <div class="card-top">
        <div class="left">
          <div class="text">
            <h3 class="truncate" matTooltip="{{ quiz.quiz_name }}">
              {{ quiz.quiz_name }}
            </h3>
            <p class="course-name m-0">{{ quiz.course_title }}</p>
            <p class="course-des" matTooltip="{{ quiz.description }}">{{ truncateText(quiz.description || '', 100) }}</p>
            <div class="meta-info">
              <div class="meta-item">
                <i class="bi bi-question-circle me-2"></i>
                <span>{{ quiz.questions?.length || 0 }} Q</span>
              </div>

              <div class="meta-item">
                <i class="bi bi-clock me-2"></i>
                <span>{{ quiz.created_at | date: timeFormat }}</span>
              </div>

              <div
                class="meta-item icon-link"
                *ngIf="quiz.status === 'Published' && quiz.links_count"
              >
                <i class="bi bi-link"></i> {{ quiz.links_count }} Link
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <button
        class="add-btn"
        type="button"
        *ngIf="quiz.status === 'Draft'"
        (click)="changeQuizStatus(quiz.quiz_id)"
      >
        Publish & Generate Link
      </button>

      <div class="action-row">
        <button class="action-tile" (click)="onViewQuiz(quiz.quiz_id)">
          <i class="bi bi-pencil"></i>
          <span>Edit Quiz</span>
        </button>

        <button class="action-tile" (click)="onViewQuiz(quiz.quiz_id)">
          <i class="bi bi-eye"></i>
          <span>View Questions</span>
        </button>

        <button
          class="action-tile"
          (click)="goToGenerativeDetailPage(quiz.quiz_id)"
        >
          <i class="bi bi-link-45deg"></i>
          <span>View Links</span>
          <p class="link-badge" *ngIf="quiz.links_count">{{ quiz.links_count }}</p>
        </button>
      </div>
    </div>
  </div>
</section>

<div class="pagination-wrapper" *ngIf="totalRecords > limit && !isLoading">
  <button
    class="nav-btn"
    [disabled]="page === 1"
    (click)="changePage(page - 1)"
  >
    ‹
  </button>

  <div class="page-pill">
    <button
      *ngFor="let p of visiblePages"
      class="page-number"
      [class.active]="p === page"
      (click)="changePage(p)"
    >
      {{ p }}
    </button>
  </div>

  <button
    class="nav-btn"
    [disabled]="page === totalPages"
    (click)="changePage(page + 1)"
  >
    ›
  </button>
</div>

<div class="pagination-skeleton" *ngIf="isLoading">
  <span></span>
  <span></span>
  <span></span>
</div>

<!-- <div class="custom-modal" *ngIf="isModalOpen">
  <form [formGroup]="quizForm">

    <div class="modal-header">
      <h4 class="create-account text-center">Create New Quiz</h4>
      <button class="close-btn" type="button" (click)="closeModal()"></button>
    </div>

    <div class="modal-body">
      <label for="quizTitle">Quiz Title</label>
      <input id="quizTitle" class="quiz-input mb-2" type="text" formControlName="quiz_name"
        placeholder="Enter Your Quiz Title" />


      <label>Select Course</label>

      <div class="search-dropdown mb-3" (click)="$event.stopPropagation()">

        <input type="text" class="search-input" placeholder="Search course..." [(ngModel)]="searchText"
          [ngModelOptions]="{ standalone: true }" (focus)="openDropdown()" (input)="openDropdown()" />
        <div class="selected-course" *ngIf="selectedCourse">
          Selected: <strong>{{ selectedCourse.name }}</strong>
        </div>

        <div class="dropdown-list" *ngIf="isDropdownOpen">

          <div class="dropdown-item" *ngFor="let course of filteredCourses" (click)="selectCourse(course)">
            {{ course.name }}
          </div>

          <div *ngIf="hasMore()" class="dropdown-item text-center">
            <button (click)="loadCourses()" [disabled]="loading" class="btn-add">
              {{ loading ? 'Loading...' : 'Load More' }}
            </button>
          </div>

          <div class="dropdown-item empty" *ngIf="searchText.length >= 1 && filteredCourses.length === 0">
            No courses found
          </div>
        </div>
      </div>

      <label>Time Limit</label>
      <div class="time-limit-section">
        <div class="time-inputs">
          <div class="time-field mb-2">
            <input type="number" min="0" placeholder="00" formControlName="hours" />
            <span>Hrs</span>
          </div>

          <div class="time-field mb-2">
            <input type="number" min="0" max="60" placeholder="00" formControlName="minutes" />
            <span>Min</span>
          </div>

          <div class="time-field mb-2">
            <input type="number" min="0" max="60" placeholder="00" formControlName="seconds" />
            <span>Sec</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeModal()">Cancel</button>

      <button class="create-btn" type="button" (click)="createQuiz()" [disabled]="quizForm.invalid || isCreating">

        <ng-container *ngIf="isCreating; else createText">
          <span class="spinner-text">
            <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
            Creating...
          </span>
        </ng-container>

        <ng-template #createText>
          <i class="bi bi-plus"></i>
          Create Quiz
        </ng-template>

      </button>
    </div>
  </form>
</div> -->
